<template>
    <div>
        <!--Patient SignUp-->
        <v-dialog
            v-model="show"
            fullscreen
            scrollable
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-toolbar dark color="primary" fixed>
                <v-btn icon dark @click="cancel">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Ingresar Paciente</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark flat :disabled="!valid || loader" @click="patientSignUp">
                        <v-icon class="mr-1">save</v-icon>
                        Guardar
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card class="mt-4">


                <div class="loading-container">
                    <v-progress-linear
                        v-show="loadingSignUp"
                        color="black"
                        height="2"
                        :indeterminate="true"
                        class="ma-0"
                    ></v-progress-linear>
                </div>

                <v-sheet color="white darken-3 pa-3 mt-4">
                    <v-container>
                        <v-layout wrap justify-center align-center mt-4>
                            <v-flex xs12 md10 lg8 xl6 text-xs-center mt-4>
                                <patient-form
                                    :required-fields="requiredFields"
                                    :requested-fields="requestedFields"
                                    :provider-id="providerId"
                                    ref="patientForm"
                                    :is-foreign="isForeign"
                                    :value="user"
                                    v-on:update:valid="valid = $event"/>
                            </v-flex>

                        </v-layout>

                    </v-container>
                </v-sheet>

            </v-card>

        </v-dialog>

    </div>

</template>

<script>

import PatientForm from './PatientForm'

import {mapState, mapMutations} from 'vuex'
import {ApiUtils} from '@/utils/ApiUtils'

import {getLabel} from '@/utils/Institution'

export default {
    props: [
        'onSignUpSuccess',
        'onCancel',
        'dni',
        'isForeign',
        'model',
        'internal',
        'requiredFields',
        'requestedFields',
        'providerId'
    ],
    components: {PatientForm},
    mounted() {
        var vm = this
    },
    data(vm) {
        return {
            loadingSignUp: false,
            valid: false,
            show: this.model || false,

            disabled: false,
        }
    },
    watch: {
        show(val) {
            if (!val) {
                if(this.$refs.patientForm) this.$refs.patientForm.reset()
                if (typeof this.onCancel == 'function') {
                    this.onCancel()
                }
            } else {
                if(this.$refs.patientForm) this.$refs.patientForm.setDefault()
            }
        },
        model(newValue) {
            this.show = newValue
        },
    },
    computed: {
        ...mapState(['loader', 'currentBranchOffice', 'currentProvider']),
        isInternal() {
            return this.internal !== undefined && this.internal !== false
        },
        user() {
            var vm = this
            return {
                dni: vm.dni,
            }
        }
    },
    methods: {
        ...mapMutations([
            'showLoader',
            'hideLoader',
            'showSnackBar',
        ]),
        cancel() {
            if (typeof this.onCancel == 'function') {
                this.show = false
                this.onCancel()
            }
        },
        async patientSignUp() {

            var vm = this
            let user = vm.$refs.patientForm.getUserData()

            const response = await vm.submitSignUp(user)

            if (!response.ok) {
                const json = await response.json()
                var validationErrors = []
                for (let attr in json.result) {
                    validationErrors.push(json.result[attr][0])
                }

                vm.showSnackBar(validationErrors.join(',') || json.message || 'Ocurrió un error registrando al ' + getLabel('commons.client'))
                return
            }

            vm.show = false

            if (typeof vm.onSignUpSuccess == 'function') {
                const json = await response.json()
                vm.onSignUpSuccess(json.result.user)
            }
        },
        async submitSignUp(user = {}) {

            var vm = this
            let endpoint = vm.isInternal && vm.currentProvider ?
                `providers/${vm.currentProvider.id}/client` : 'signup/patient'

            vm.showLoader()
            console.log('user',user)
            const response = await ApiUtils.makePost(endpoint, user)
            vm.hideLoader()

            return response

        }
    }
}
</script>

<style scoped>
.loading-container {
    padding: 0;
    height: 2px;
    width: 100%;
}
</style>